<template>
  <b-table class="sticky-table-header" :data="billets" hoverable>
    <b-table-column
      field="billets.createdAt"
      :label="$t('buyNowPayLater.date')"
      v-slot="props"
    >
      {{
        new Date(props.row.createdAt).toLocaleDateString(
          undefined,
          transactionDateFormat
        )
      }}
    </b-table-column>

    <b-table-column
      field="billets.adyen.response.action.downloadUrl"
      :label="$t('buyNowPayLater.link')"
      v-slot="props"
    >
      <a :href="props.row.adyen.response.action.downloadUrl">Link</a>
    </b-table-column>

    <b-table-column
      field="billets.adyen.response.action.reference"
      :label="$t('buyNowPayLater.billetNumber')"
      v-slot="props"
    >
      {{ props.row.adyen.response.action.reference }}
    </b-table-column>

    <b-table-column
      field="billets.details.status"
      :label="$t('buyNowPayLater.status')"
      v-slot="props"
    >
      {{
        props.row.details.status === "paid"
          ? $t("buyNowPayLater.paid")
          : props.row.details.status === "pending"
          ? $t("buyNowPayLater.pending")
          : props.row.details.status === "cancelled"
          ? $t("buyNowPayLater.cancelled")
          : props.row.details.status === "expired"
          ? $t("buyNowPayLater.expired")
          : "?"
      }}
    </b-table-column>

    <template slot="empty">
      <table-empty-template />
    </template>
  </b-table>
</template>

<script>
import tableEmptyTemplate from "../common/TableEmptyTemplate";

export default {
  props: ["billets"],

  components: {
    tableEmptyTemplate
  },

  data() {
    return {
      transactionDateFormat: {
        year: "2-digit",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      }
    };
  }
};
</script>
